import c1 from "./Images/Illustration/bmw-offer.ecfb9ac1bf7b5ef615a6.png";
import c2 from "./Images/Illustration/nissan-offer.6eddc86310b7cac538ae.png";
import c3 from "./Images/Illustration/toyota-offer-2.861de085d1c782df9e9d.png";
import c4 from "./Images/Illustration/offer-toyota.4b2435e447a7832d9f4a.png";
import c5 from "./Images/Illustration/marcedes-offer.d177a4fe9e2002ddb24d.png";
import c6 from "./Images/Illustration/about.1044506a3d3cb06c91b2.png";
const Cars = () => {
    return (
        <section class='container-fluid'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Cars</h3>

                    <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Cars">Cars</li>
                        </ol>
                    </nav></div>

                </div>
                <div class='col-12 col-md-4 py-5'>
                    <div className="py-5">

                        <ul className="bg-secondary-subtle text-center p-3">
                            <li className="bg-white m-1">All Brands (2376)</li>
                            <li className="bg-white m-1">Toyota (237)</li>
                            <li className="bg-white m-1">Nissan (23)</li>
                            <li className="bg-white m-1">Mercedes (258)</li>
                            <li className="bg-white m-1">Hyundai (67)</li>
                            <li className="bg-white m-1">Audi (123)</li>
                            <li className="bg-white m-1">Datsun  (23)</li>
                        </ul>

                    </div>
                    <div className="py-5">

                        <ul className="bg-secondary-subtle text-center p-3">
                            <li className="bg-white m-1"><input type="text" class="form-control" id="formGroupExampleInput" placeholder="From Address" />
                            </li>
                            <li className="bg-white m-1"><input type="text" class="form-control" id="formGroupExampleInput" placeholder="To Address" /></li>

                            <li className="bg-white m-1"> <select id="inputState" class="form-select">
                                <option selected>Ac Car</option>
                                <option>Non Ac Car</option>
                            </select></li>
                            <li className="bg-white m-1"><input type="text" class="form-control" id="formGroupExampleInput" placeholder="Journey Date" /></li>
                            <li className="bg-white m-1"><input type="text" class="form-control" id="formGroupExampleInput" placeholder="Journey Time" /></li>
                            <li className="bg-white m-1">  <a className="btn" href="#">Find Car</a></li>

                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-8 py-5">
                    <div className="row">
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c1} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">BMW X3</h5>
                                    <p class="card-text">$50.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c2} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">Nissan 370Z</h5>
                                    <p class="card-text">$75.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row py-5">
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c3} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">Toyota Camry</h5>
                                    <p class="card-text">$55.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c5} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">Marcedes S-Class</h5>
                                    <p class="card-text">$50.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row ">
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c6} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">Audi Q3</h5>
                                    <p class="card-text">$45.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="card p-2 text-center" >
                                <img src={c5} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title">Audi Q3</h5>
                                    <p class="card-text">$50.00/ Day</p>
                                    <a href="#" class="btn fw-bold ">Rent Car</a>
                                    <a href="#" class="btn bg-dark text-white border border-0">Details</a>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
};

export default Cars;
